import { render, staticRenderFns } from "./GroupDeletePopup.vue?vue&type=template&id=1b20ee04&scoped=true&"
import script from "./GroupDeletePopup.vue?vue&type=script&lang=js&"
export * from "./GroupDeletePopup.vue?vue&type=script&lang=js&"
import style0 from "./GroupDeletePopup.vue?vue&type=style&index=0&id=1b20ee04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20ee04",
  null
  
)

export default component.exports